export const MAX_EMBED_WIDTH = 700;
export const MIN_EMBED_WIDTH = 100;
export const MAX_EMBED_HEIGHT = 2500;
export const MIN_EMBED_HEIGHT = 200;
